<template>
  <form class="mt-2" id="form-modal">
    <!-- description input -->
    <div class="form-group">
      <label class="label-form">Label<span style="color: red">*</span>:</label>
      <input class="form-control"  type="date" v-model="trial_date"/>
      
    </div>

    <!-- buttons -->
    <div class="form-footer text-right">
      
      <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">
        Close
      </button>
      



      <button type="button" :style= "[isMiniLoading ? { 'cursor' : 'default' } : { 'cursor' : 'pointer' }]" :disabled="isMiniLoading" class="btn btn-primary btn-sm ml-1" @click="save">
        <font-awesome-icon v-if="isMiniLoading" icon="spinner" style="animation: spin 2s linear infinite; float:right; margin-left: 5px; margin-top: 3px;" />
        Save
      </button>

      

    </div>

<!-- <table class="table table-bordered table-hover  mt-5 text-center">
            <colgroup>
              <col class="col-md-4" />
              <col class="col-md-12" />
            </colgroup>
            <tbody>
              <tr>
                <th>label</th>
                <th>URL</th>
                <th>Action</th>
              </tr>
              
              <tr class="mt-2" v-for="(demo, index) in demo_url" :key="demo.id">
                
                <td  style="width: 60%;"> <p style="white-space: break-spaces">{{ demo.label }}</p> </td>
                <td  style="width: 30%;"> <p style="white-space: break-spaces">{{ demo.video_link }}</p> </td>
                <td  style="width: 10%;">
                  <div class="btn-group">
                    <a class="btn dropdown-toggle" data-toggle="dropdown" href="#">
                      <span class="fas fa-ellipsis-v"></span>
                    </a>
                    <ul class="dropdown-menu" style="min-width: 12rem !important">
                      <a class="dropdown-item" @click="updateVideoUrl(index)">Edit</a>
                      <a class="dropdown-item " style="color: rgb(247, 7, 7);" @click="deleteurl(demo.id)">Delete</a>
                    </ul>
                  </div>
                </td>
              </tr>
              <h5 style="text-align: center; position: absolute; transform: translateX(180px); margin-top: 24px;" v-if="demo_url.length<1">
      No Url's found.
    </h5>
            </tbody>
          </table> -->



  </form>

</template>
<script>
  // import Multiselect from 'vue-multiselect';
  import axios from "axios";

  export default {
    props: ["action", "formData"],
    data: function () {
      return {
        isMiniLoading: false,
        trial_date:'',
        filter_status: "",
      
      };
    },
   

    created :  function (){
      var d = new Date();
      d.setDate(d.getDate() + 30);
      this.trial_date = d.toISOString().slice(0, 10)
      this.filter_status = localStorage.getItem('filter_status');

    },
    computed: {
    },


    methods: {
      save() {
      //  let loader = this.$loading.show({
      //     loader: 'dots',
      //   });
        this.filter_status = localStorage.getItem('filter_status');
        
        let status_selected = this.formData.status_selected;
        let org_id = this.formData.org_ids;
        let trial_date = this.trial_date;
        if(trial_date==""){
              this.$toast.warning("Please Fill Label Field.");  
              // loader.hide();
        }
          
        if (trial_date.replace(/\s/g, "").length ) {
          this.isMiniLoading = true;
          this.$store
            .dispatch("users/changeStatus", [status_selected, org_id, trial_date])
            .then(() => {
                    this.isMiniLoading = false;
                    this.$store.dispatch("users/getAllDemoLeads", [
                    this.formData.page,
                    this.formData.search,
                    this.formData.tab,
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    0,
                  ]).then(() => {});
              this.$toast.success('Status Successfully Changed');
            });
              window.$("#modal").modal("hide");
        
        } else {
          
          this.isMiniLoading = false;
        }
      },
      

    },

  };
</script>